export default __webpack_public_path__ + "static/media/customerService-white.32a6af65.svg";